import { useEffect, useRef, useState } from 'react';

const steps = [
  {
    num: '01',
    title: 'Llamas o escribes',
    desc: 'Contáctanos por teléfono o WhatsApp. Te atendemos con gusto y te ayudamos a armar tu pedido.',
  },
  {
    num: '02',
    title: 'Confirmamos contigo',
    desc: 'Revisamos disponibilidad, te confirmamos tiempos de entrega y el valor aproximado.',
  },
  {
    num: '03',
    title: 'Recibes en tu puerta',
    desc: 'Tu domicilio llega directo a tu casa. Pagas al recibir: efectivo, transferencia o Nequi.',
  },
];

export default function ComoPides() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="como-pides"
      ref={ref}
      className="bg-white py-[72px] md:py-24"
    >
      <div className="mx-auto max-w-[1120px] px-6 md:px-12">
        <h2 className="mx-auto mb-16 max-w-[600px] text-center font-serif text-[28px] font-bold leading-[1.2] text-md-ink md:text-[42px]">
          Pedir tu domicilio toma menos de un minuto
        </h2>

        <div className="grid gap-8 md:grid-cols-3">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`group rounded-2xl border-[1.5px] border-md-sky bg-white p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(15,31,53,0.12)] ${
                visible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${i * 150}ms` }}
            >
              <span className="font-serif text-[56px] font-light leading-none text-md-blue md:text-[64px]">
                {step.num}
              </span>
              <div className="mb-5 mt-4 h-[3px] w-10 rounded-full bg-md-teal" />
              <h3 className="mb-3 font-sans text-[18px] font-semibold text-md-ink md:text-[20px]">
                {step.title}
              </h3>
              <p className="text-[15px] leading-[1.6] text-md-slate md:text-[16px]">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}